<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2024-09-05 09:52:00
 * @LastEditTime: 2024-12-25 16:11:57
 * @LastEditors: hexy
 * @Description  : 调量管理
 * @FilePath: \ICPSxin\src\views\platform\ICPS\smart\adjustQuantity.vue
-->
<template>
    <div class="pages_content table">
        <el-container>
            <el-header>
                <breaDcrumb />
            </el-header>
            <el-main style="display: flex">
                <div>
                    <!-- 导航 -->
                    <el-collapse-transition>
                        <div v-show="showCardNav">
                            <div class="search">
                                <span style="display: inline-block; margin-bottom: 10px">
                                    <span style="margin-right: 12px">工程名称</span>
                                    <el-input v-model="tableParam.outEngineeringName" placeholder="请输入"
                                        style="width: 150px"></el-input>
                                </span>
                                <span style="margin-left: 24px">
                                    <span style="margin-right: 12px">合同签订单位</span>
                                    <el-input v-model="tableParam.signingUnit" placeholder="请输入"
                                        style="width: 150px"></el-input>
                                </span>
                                <span style="margin-left: 24px">
                                    <span style="margin-right: 12px">调量类型</span>
                                    <el-select v-model="tableParam.adjustmentTypeId" placeholder="请选择" style="width: 150px"
                                        filterable>
                                        <el-option v-for="(item, index) in adjustmentTypeList" :key="index"
                                            :label="item.itemName" :value="item.id"></el-option>
                                    </el-select>
                                </span>
                                <span style="margin-left: 24px">
                                    <span style="margin-right: 12px">状态</span>
                                    <el-select v-model="tableParam.approvalStatus" placeholder="请选择" style="width: 150px"
                                        filterable>
                                        <el-option v-for="(item, index) in statusList" :key="index" :label="item.name"
                                            :value="item.id"></el-option>
                                    </el-select>
                                </span>
                                <el-button icon="el-icon-search" size="medium" class="bottom_all"
                                    @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                                <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重
                                    置</el-button>
                            </div>
                        </div>
                    </el-collapse-transition>
                    <div class="hr"></div>
                    <div class="card">
                        <div class="card_nav">
                            <div>
                                <el-button v-if="ButtonList.findIndex(res => (res.buttonValue == 'TIANJIA')) !== -1" size="small"
                                    class="bottom_all" style="margin-left: 0" @click="rest(), addFromDate('添加')">
                                    <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                                    添加
                                </el-button>
                            </div>
                            <div>
                                <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
                                    <el-link :underline="false">
                                        <span class="el-icon--left">
                                            <i class="iconfont iconicon_button_filtrate"></i>
                                        </span>
                                        筛选
                                    </el-link>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for="(item, index) in table" :key="index">
                                            <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                        <div v-loading="tableLoading" class="card_info" :style="style">
                            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }"
                                border stripe :height="screenHeight - 450" style="width: 100%" :data="tableData"
                                tooltip-effect="dark">
                                <template v-for="(item, index2) in table">
                                    <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                                        :width="item.width">
                                        <template slot-scope="scope">
                                            <span v-if="item.label == '税率'">
                                                <span>{{ scope.row.taxRate ? scope.row.taxRate * 100 + '%' : '' }}</span>
                                            </span>
                                            <span v-else-if="item.label == '状态'">
                                                <span>{{ statusList[scope.row.approvalStatus]?.name }}</span>
                                            </span>
                                            <span v-else-if="item.label == '附件'">
                                                <el-button class="bottom_one" size="mini"
                                                    @click="lookFile(scope.row)">查看</el-button>
                                            </span>
                                            <span v-else-if="item.label == '操作'">
                                                <el-button
                                                    v-if="(scope.row.approvalStatus == 0 || scope.row.approvalStatus == 3) && ButtonList.findIndex(res => (res.buttonValue == 'XIUGAI')) !== -1"
                                                    class="bottom_one" size="mini" @click="open(scope.row)">修改</el-button>
                                                <el-button
                                                    v-if="scope.row.approvalStatus == 0 || scope.row.approvalStatus == 3"
                                                    class="bottom_one" size="mini" @click="sign(scope.row)">提交</el-button>
                                                <el-button
                                                    v-if="scope.row.approvalStatus == 1 || scope.row.approvalStatus == 2"
                                                    class="bottom_one" size="mini" @click="look(scope.row)">查看</el-button>
                                                <el-button
                                                    v-if="scope.row.approvalStatus == 1 || scope.row.approvalStatus == 2"
                                                    class="bottom_one" size="mini"
                                                    @click="upFile(scope.row)">上传附件</el-button>
                                            </span>
                                            <span v-else>{{ scope.row[item.prop] }}</span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                        </div>
                    </div>
                </div>
            </el-main>
            <div class="card_bottom">
                <div class="card_bottom_left">
                    <div class="top_page_totle">总共{{ total }}条</div>
                    <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
                        :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper"
                        :total="total" @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
                </div>
                <div>
                    <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
                        @click="gettableData">刷新</el-button>
                </div>
            </div>
        </el-container>
        <!-- 添加 -->
        <el-dialog v-dialogDrag :visible.sync="addDialog" width="760px" :close-on-click-modal="false"
            :before-close="resetFromDate">
            <span slot="title" class="dialog-title">{{ editType ? '修改' : '添加' }}</span>
            <div>
                <el-form ref="reffromDate" :rules="rules" :inline="true" :model="fromDate" label-width="110px"
                    :disable="lookType" :disabled="lookType">
                    <div style="font-size: 18px;">调出信息</div>
                    <el-form-item prop="adjustmentTypeId">
                        <span slot="label">调整类型</span>
                        <el-select ref="adjustmentTypeId" v-model="fromDate.adjustmentTypeId" placeholder="请选择" filterable
                            @change="
                                $nextTick(() => {
                                    fromDate.adjustmentTypeName = $refs.adjustmentTypeId.selectedLabel;
                                })
                                ">
                            <el-option v-for="item in adjustmentTypeList" :key="item.id" :label="item.itemName"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="mouthReportDate">
                        <span slot="label">月报生效时间</span>
                        <el-date-picker v-model="fromDate.mouthReportDate" type="date" value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间"> </el-date-picker>
                    </el-form-item>
                    <el-form-item prop="adjustmentStartTime">
                        <span slot="label">调量开始时间</span>
                        <el-date-picker v-model="fromDate.adjustmentStartTime" type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"> </el-date-picker>
                    </el-form-item>
                    <el-form-item prop="adjustmentEndTime">
                        <span slot="label">调量结束时间</span>
                        <el-date-picker v-model="fromDate.adjustmentEndTime" type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"> </el-date-picker>
                    </el-form-item>
                    <el-form-item prop="outEngineeringNameId">
                        <span slot="label">工程名称</span>
                        <el-select ref="outEngineeringNameId" v-model="fromDate.outEngineeringNameId" placeholder="请选择"
                            filterable>
                            <el-option v-for="item in engineeringList" :key="item.id" :label="item.name" :value="item.id"
                                @click.native="changeEngineeringList(item)"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="materialId">
                        <span slot="label" style="color: #ff0000">产品信息</span>
                        <span v-if="selectTableData.length > 0" style=" color: #00b85c " @click="chooseProduct()">请查看</span>
                        <span v-else style=" color: #00b85c " @click="chooseProduct()">请选择</span>
                    </el-form-item>
                    <el-form-item>
                        <span slot="label">合同签订单位</span>
                        <el-input v-model="fromDate.signingUnit" disabled placeholder="请选择工程" clearable></el-input>
                    </el-form-item>
                    <el-form-item prop="vender">
                        <span slot="label">税率</span>
                        <el-input v-model="fromDate.taxRate" disabled placeholder="请选择工程" clearable></el-input>
                    </el-form-item>
                    <div style="font-size: 18px;">调入信息</div>
                    <el-form-item prop="inEngineeringNameId">
                        <span slot="label">工程名称</span>
                        <el-select ref="inEngineeringNameId" v-model="fromDate.inEngineeringNameId" placeholder="请选择"
                            filterable @change="
                                $nextTick(() => {
                                    fromDate.inEngineeringName = $refs.inEngineeringNameId.selectedLabel;
                                })
                                ">
                            <el-option v-for="item in engineeringList" :key="item.id" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="resetFromDate">取 消</el-button>
                <el-button class="bottom_all" :disabled="lookType" style="margin-left: 24px"
                    @click="pagessubmitFromDate()">确定</el-button>
            </span>
        </el-dialog>
        <!-- 产品信息 -->
        <el-dialog v-dialogDrag :visible.sync="productDig" top="5vh" width="760px" :close-on-click-modal="false">
            <span slot="title" class="dialog-title">产品信息</span>
            <div>
                <div style="display: flex; justify-content: flex-start; align-items: center; width: 100%;margin:10px 0px;">
                    <span style="font-size: 18px; ">已选择调量明细</span>
                    <div style="margin-left: auto;">
                        <el-button class="bottom_two" size="mini" :disabled="lookType" @click="deleteProductAll()">删除</el-button>
                    </div>
                </div>
                <el-table ref="multipleTableOne" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                    :height="screenHeight / 2 - 200" style="width: 100%" :data="selectTableData" tooltip-effect="dark"
                    @selection-change="handleSelectionChangeOne">
                    <el-table-column type="selection" width="55" align="center"></el-table-column>
                    <el-table-column label="站点" prop="stationName" align="center"></el-table-column>
                    <el-table-column label="工程名称" prop="engineeringName" align="center"></el-table-column>
                    <el-table-column label="产品信息" prop="productName" align="center"></el-table-column>
                    <el-table-column label="浇筑方式" prop="pourMethod" align="center"></el-table-column>
                    <el-table-column label="调出月报量" prop="amount" align="center"></el-table-column>
                    <el-table-column label="操作" prop="" align="center">
                        <template slot-scope="scope">
                            <span>
                                <el-button class="bottom_two" size="mini" :disabled="lookType"
                                    @click="deleteProductItem(scope.$index)">删除</el-button>
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="display: flex; justify-content: flex-start; align-items: center; width: 100%; margin:10px 0px;">
                    <span style="font-size: 18px; ">查询调量明细</span>
                    <div style="margin-left: auto;">
                        <el-button class="bottom_one" size="mini" :disabled="lookType" @click="addProductAll()">添加</el-button>
                    </div>
                </div>
                <el-table  ref="multipleTableTwo" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                    :height="screenHeight / 2 - 200" style="width: 100%" :data="allTableData" tooltip-effect="dark"
                    @selection-change="handleSelectionChangeTwo">
                    <el-table-column type="selection" width="55" align="center"></el-table-column>
                    <el-table-column label="站点" prop="stationName" align="center"></el-table-column>
                    <el-table-column label="工程名称" prop="engineeringName" align="center"></el-table-column>
                    <el-table-column label="产品信息" prop="productName" align="center"></el-table-column>
                    <el-table-column label="浇筑方式" prop="pourMethod" align="center"></el-table-column>
                    <el-table-column label="调出月报量" prop="amount" align="center"></el-table-column>
                    <el-table-column label="操作" prop="" align="center">
                        <template slot-scope="scope">
                            <span>
                                <el-button class="bottom_one" size="mini" :disabled="lookType"
                                    @click="addProductItem(scope.row)">添加</el-button>
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="closeProduct">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 附件查看 -->
        <el-dialog v-dialogDrag :visible.sync="fileDig" top="15vh" width="560px" :close-on-click-modal="false">
            <span slot="title" class="dialog-title">附件</span>
            <div>
                <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                    :height="screenHeight / 2 - 100" style="width: 100%" :data="fileTableData" tooltip-effect="dark">
                    <el-table-column label="文件名称" prop="fileName" align="center">
                        <template slot-scope="scope">
                            <span>
                                <el-link type="sucess" :underline="false" @click="lookFileDetail(scope.row)">{{
                                    scope.row.fileName }}</el-link>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" prop="" align="center">
                        <template slot-scope="scope">
                            <span>
                                <el-button class="bottom_two" size="mini"
                                    @click="deleteFile(scope.row, scope.$index)">删除</el-button>
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="closeFile">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 上传附件 -->
        <el-dialog v-dialogDrag :visible.sync="uploadFileDig" width="680px" :close-on-click-modal="false">
            <span slot="title" class="dialog-title">上传附件</span>
            <div v-loading="loading" element-loading-text="上传中..." element-loading-background="rgba(0, 0, 0, 0.8)"
                class="dialoginfo" style="text-align: center">
                <el-upload class="upload-demo" :on-success="fileSuccess" :before-upload="filebefore" :show-file-list="false"
                    drag action="/resource/resources/upload" name="file" :headers="upheader">
                    <i slot="trigger" class="el-icon-upload"></i>
                    <div slot="trigger" class="el-upload__text">
                        将文件拖到此处，或
                        <em>点击选取文件</em>
                    </div>
                    <div slot="tip" class="el-upload__tip" style="color:red">*{{upload_tip}}</div>
                </el-upload>
                <div style="margin-top: 10px;font-size:18px">
                    待保存文件:<span style="color: #00b85c;margin-left: 10px;">{{ fileObj.fileName }}</span>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="uploadFileDig = false">关 闭</el-button>
                <el-button class="bottom_all_two" @click="saveFile">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryPage, saveData, updateData, queryEngineerings, queryTableProduct, queryProduct, uploadEnclosure, deleteEnclosure } from "@/api/smart/adjustQuantity.js";
import { getToken } from "@/utils/auth";
import { getDicType } from "@/api/common.js";
import { UPLOAD_TIP } from "@/utils/utils";
export default {
    components: {},
    mixins: [mixin],
    data() {
        return {
            table: [
                { label: "月报生效时间", prop: "mouthReportDate", status: true, width: "135" },
                { label: "调量开始时间", prop: "adjustmentStartTime", status: true, width: "135" },
                { label: "调量结束时间", prop: "adjustmentEndTime", status: true, width: "135" },
                { label: "调整类型", prop: "adjustmentTypeName", status: true, width: "100" },
                { label: "工程名称", prop: "outEngineeringName", status: true, width: "auto" },
                { label: "合同签订单位", prop: "signingUnit", status: true, width: "auto" },
                { label: "税率", prop: "taxRate", status: true, width: "80" },
                { label: "附件", prop: "dateOdProduction", status: true, width: "80" },
                { label: "调整人", prop: "createUserName", status: true, width: "90" },
                { label: "状态", prop: "checkUnit", status: true, width: "100" },
                { label: "操作", prop: "", status: true, width: "200" },
            ],
            queryPage: queryPage,
            pagesType: 0,
            tableData: [],
            statusList: [
                {
                    id: "0",
                    name: "待提交"
                },
                {
                    id: "1",
                    name: "审批中"
                },
                {
                    id: "2",
                    name: "审核通过"
                },
                {
                    id: "3",
                    name: "审核不通过"
                },
            ],
            /*添加*/
            adjustmentTypeList: [],
            engineeringList: [],
            fromDate: {
                adjustmentTypeId: "",//调整类型id,字典数据
                adjustmentTypeName: "",//调整类型,字典数据
                mouthReportDate: "",//月报生效时间
                adjustmentStartTime: "",//调量开始时间
                adjustmentEndTime: "",//调量结束时间
                outEngineeringName: "",//调出工程
                outEngineeringNameId: "",//调出工程ID
                signingUnit: "",//合同签订单位
                signingUnitId: "",//合同签订单位ID
                taxRate: null,//税率
                inEngineeringName: "",//调入工程
                inEngineeringNameId: "",//调入工程id
                productList: [//产品信息
                ]
            },
            listFilesa: [],
            rules: {
                adjustmentTypeId: [{ required: true, message: "请选择调整类型", trigger: "change" }],
                mouthReportDate: [{ required: true, message: "请选择月报生效时间", trigger: "change" }],
                adjustmentStartTime: [{ required: true, message: "请选择调量开始时间", trigger: "change" }],
                adjustmentEndTime: [{ required: true, message: "请选择调量结束时间", trigger: "change" }],
                outEngineeringNameId: [{ required: true, message: "请选择工程名称", trigger: "change" }],
                inEngineeringNameId: [{ required: true, message: "请选择工程名称", trigger: "change" }],
            },
            productDig: false,
            allTableData: [],
            selectTableData: [],
            editType: false,
            lookType: false,
            low: {},
            fileDig: false,
            fileTableData: [],
            upheader: {},
            uploadFileDig: false,
            loading: false,
            fileObj: {
                adjustId: "",//主数据id
                fileName: "",//文件名
                path: ""//路径
            },
            multipleSelectionOne:[], //已选择
            multipleSelectionTwo:[], 
            upload_tip:UPLOAD_TIP,
        };
    },
    watch: {},
    async created() {
        this.upheader = {
            "access-token": getToken(),
        };
        this.tableParam = { ...this.tableParam, adjustmentTypeId: "", approvalStatus: "", outEngineeringName: "", signingUnit: "" };
        this.gettableData();
        getDicType({ code: "adjustmentType" }).then(res => {
            this.adjustmentTypeList = res.data.items; //
        });
        queryEngineerings().then(res => {
            if (res.code == 1001) {
                this.engineeringList = res.data
            }
        })
    },
    methods: {
        lookFileDetail(row) {
            if (row.path.endsWith('.jpg') || row.path.endsWith('.png') || row.path.endsWith('.jpeg')) {
                let imgUrl = 'https://lvshe.huashijc.com/file/' + row.path;
                window.open(imgUrl, "_blank");
            } else {
                this.$wps(row.path);
            }
        },
        sign(row) {
            this.$router.push({ name: "adjustQuantity_sign", query: { ...row, type: 1 } });
        },
        saveFile() {
            uploadEnclosure(this.fileObj).then(res => {
                if (res.code == 1001) {
                    this.$message.success('保存成功!')
                    this.uploadFileDig = false
                    this.gettableData()
                }
            })
        },
        upFile(low) {
            this.low = JSON.parse(JSON.stringify(low))
            this.fileObj = this.$options.data().fileObj
            this.fileObj.adjustId = this.low.id
            this.uploadFileDig = true
        },
        closeFile() {
            this.fileDig = false
        },
        deleteFile(row, index) {
            this.$confirm('此操作将删除该附件?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                cancelButtonClass: 'bottom_all_two',
                confirmButtonClass: 'bottom_all',
                type: 'warning'
            })
                .then(() => {
                    deleteEnclosure({ id: row.id }).then(res => {
                        if (res.code == 1001) {
                            this.fileTableData.splice(index, 1)
                            this.gettableData();
                        }
                    })
                })
                .catch(() => { });
        },
        lookFile(row) {
            this.low = JSON.parse(JSON.stringify(row))
            this.fileTableData = this.low.enclosureList
            this.fileDig = true
        },
        addProductAll() {
            // 检查是否有选中的数据
            if (this.multipleSelectionTwo.length === 0) {
              this.$message.warning('请先选择要添加的数据');
              return;
            }
            // 检查选中的数据是否已经存在于 selectTableData 中
            const hasExistingData = this.multipleSelectionTwo.some(row => {
                let index = this.selectTableData.findIndex(item => 
                    item.engineeringName === row.engineeringName &&
                    item.productName === row.productName &&
                    item.pourMethod === row.pourMethod
            );
                return index !== -1; // 如果 findIndex 返回的索引不是 -1，则表示找到了匹配项
            });
            // 如果存在已添加的数据，则提示用户
            if (hasExistingData) {
              this.$message.warning('选中的数据中包含已存在的项，无法添加');
              return;
            }
            // 没有重复数据，将选中的数据添加到 selectTableData
            this.selectTableData = this.selectTableData.concat(this.multipleSelectionTwo);
            // 从 allTableData 中移除已添加的数据
            this.multipleSelectionTwo.forEach(row => {
                this.allTableData = this.allTableData.filter(item => 
                    item.engineeringName !== row.engineeringName ||
                    item.productName !== row.productName ||
                    item.pourMethod !== row.pourMethod
                );
            });
            // 清空选中的数据
            this.multipleSelectionTwo = [];
            // 提示添加成功
            this.$message.success('添加成功');
        },
        addProductItem(row) {
            let index = this.selectTableData.findIndex(item => item.engineeringName == row.engineeringName && item.productName == row.productName && item.pourMethod == row.pourMethod)
            if (index !== -1) {
                this.$message.warning('已添加过该条数据！')
                return
            }
            let obj = {
                engineeringName: row.engineeringName,
                productName: row.productName,//产品名称
                pourMethod: row.pourMethod,//浇筑方式
                amount: row.amount,//调整量
                pourMethodSpit: row.pourMethodSpit,
                stationId: row.stationId,
                stationCode: row.stationCode,
                stationName: row.stationName
            }
            this.selectTableData.push(obj)
            // 从 allTableData 中移除对应的数据
            this.allTableData = this.allTableData.filter(item => 
                item.engineeringName !== row.engineeringName ||
                item.productName !== row.productName ||
                item.pourMethod !== row.pourMethod
            );
        },
        handleSelectionChangeOne(val){
            this.multipleSelectionOne = val;  // 更新选中的行数据
        },
        handleSelectionChangeTwo(val){
            this.multipleSelectionTwo = val;  // 更新选中的行数据
            console.log(this.multipleSelectionTwo)
        },
         // 删除选中数据
         deleteProductAll() {
          if (this.multipleSelectionOne.length === 0) {
            this.$message({
              type: 'warning',
              message: '请选择要删除的数据再操作'
            });
            return; 
          }
          // 删除选中的数据并尝试添加回 allTableData
          this.multipleSelectionOne.forEach(selectedItem => {
            const index = this.selectTableData.findIndex(item => 
              item.engineeringName === selectedItem.engineeringName &&
              item.productName === selectedItem.productName &&
              item.pourMethod === selectedItem.pourMethod
            );
            if (index > -1) {
              const removedItem = this.selectTableData.splice(index, 1)[0];
              // 检查 allTableData 中是否已存在该数据
              const existsInAllTableData = this.allTableData.some(item => 
                item.engineeringName === removedItem.engineeringName &&
                item.productName === removedItem.productName &&
                item.pourMethod === removedItem.pourMethod
              );
              if (!existsInAllTableData) {
                this.allTableData.push(removedItem); // 如果不存在，则添加回 allTableData
              }
            }
          });
          this.multipleSelectionOne = [];  // 清空选中的行
        },
        deleteProductItem(index) {
            const removedItem = this.selectTableData.splice(index, 1)[0];
            // 检查 allTableData 中是否已存在该数据
            const existsInAllTableData = this.allTableData.some(item => 
              item.engineeringName === removedItem.engineeringName &&
              item.productName === removedItem.productName &&
              item.pourMethod === removedItem.pourMethod
            );
            if (!existsInAllTableData) {
              this.allTableData.push(removedItem); // 如果不存在，则添加回 allTableData
            }
            // this.selectTableData.splice(index, 1)
        },
        closeProduct() {
            this.productDig = false
        },
        confirmProduct() { },
        async chooseProduct() {
            if (!this.fromDate.outEngineeringNameId || !this.fromDate.adjustmentStartTime || !this.fromDate.adjustmentEndTime) {
                this.$message.warning('请先选择工程及调量时间段！')
                return
            }
            let obj = {
                outEngineeringNameId: this.fromDate.outEngineeringNameId,//调出工程
                createTime: this.fromDate.adjustmentStartTime,//调出开始时间
                updateTime: this.fromDate.adjustmentEndTime
            }
            const res1 = await queryTableProduct(obj)
            if (res1.code == 1001) {
                this.allTableData = res1.data
            }
            if (this.editType) {
                console.log(this.low)
                const res2 = await queryProduct({ outEngineeringNameId: this.fromDate.outEngineeringNameId, id: this.low.id })
                if (res2.code == 1001) {
                    if (res2.data) {
                        this.selectTableData = res2.data
                    } else {
                        this.selectTableData = []
                    }

                }
            } else {
                if (this.selectTableData.length > 0 && this.selectTableData[0].engineeringName !== this.fromDate.outEngineeringName) {
                    this.selectTableData = []
                }

            }
            this.productDig = true
        },
        changeEngineeringList(item) {
            this.fromDate.outEngineeringName = item.name
            this.fromDate.signingUnit = item.unitName
            this.fromDate.signingUnitId = item.unitId
            this.fromDate.taxRate = item.taxRate
        },
        async open(low) {
            this.editType = true
            this.lookType = false
            this.low = JSON.parse(JSON.stringify(low))
            this.fromDate = JSON.parse(JSON.stringify(low))
            this.selectTableData = [];
            this.addDialog = true;
        },
        look(low) {
            this.lookType = true
            this.low = JSON.parse(JSON.stringify(low))
            this.fromDate = JSON.parse(JSON.stringify(low))
            this.selectTableData = [];
            this.addDialog = true;
        },
        pagessubmitFromDate() {
            let _this = this;
            _this.$refs.reffromDate.validate(valid => {
                if (valid) {
                    if (this.selectTableData.length == 0) {
                        this.$message.warning('请选择产品信息!')
                        return
                    }
                    _this.fromDate.productList = this.selectTableData
                    if (!this.editType || this.lookType) {
                        saveData(_this.fromDate).then(res => {
                            if (res.code == 1001) {
                                _this.$message.success("保存成功!");
                                _this.gettableData();
                                _this.addDialog = false;
                            }
                        });
                    } else {
                        updateData(_this.fromDate).then(res => {
                            if (res.code == 1001) {
                                _this.$message.success("修改成功!");
                                _this.gettableData();
                                _this.addDialog = false;
                            }
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        sizeChange(value) {
            this.tableParam.pageSize = value;
            this.gettableData();
        },
        /*重置数据,此方法必须存在，并且方发只重置条件*/
        init() {
            this.tableParam.adjustmentTypeId = "";
            this.tableParam.approvalStatus = "";
            this.tableParam.outEngineeringName = "";
            this.tableParam.signingUnit = "";
            this.initData();
        },
        rest() {
            this.selectTableData = [];
            this.editType = false;
            this.lookType = false;
        },
        filebefore(file) {
            this.loading = true;
            const allowedFormats = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'application/ofd'];
            const isAllowedFormat = allowedFormats.includes(file.type);
            if (!isAllowedFormat) {
                this.$message.error("数据上传必须是 doc, docx, pdf, jpeg, jpg, png, ofd 格式!");
                this.loading = false;
            }
            return isAllowedFormat;
        },
        fileSuccess(res) {
            this.loading = false;
            this.fileObj.fileName = ""
            this.fileObj.path = ""
            if (res.code === 1001) {
                this.fileObj.fileName = res.data.fileName
                this.fileObj.path = res.data.fileUrl
            }
        },
    },
};
</script>
  
<style lang="scss" scoped>
.el-input,
.el-select {
    width: 240px;
}

.table_link {
    margin: 0 10px;
    color: $bg_color;
    cursor: pointer;
}

.table_link:hover {
    opacity: 0.8;
}

.tabtop {
    width: 381px;
}
</style>
  